"use strict";

exports.__esModule = true;
exports.isStaffSelectionBeforeSlot = exports.isStaffSelectionAfterSlot = exports.isMultiServiceAppointment = exports.isLocationSelectionBeforeSlot = exports.isLocationSelectionAfterSlot = exports.isCustomerMustChooseStaff = exports.isCustomerMayChooseStaff = exports.isCustomerCannotChooseStaff = exports.isBookFlowSettingsEnabled = exports.hasRequiredBookFlowSettings = void 0;
var _types = require("@wix/ambassador-bookings-v2-bookings-settings/types");
const isMultiServiceAppointment = bookingsSettings => {
  var _bookingsSettings$mul;
  return !!((_bookingsSettings$mul = bookingsSettings.multiServiceAppointments) != null && _bookingsSettings$mul.enabled);
};
exports.isMultiServiceAppointment = isMultiServiceAppointment;
const isCustomerCannotChooseStaff = bookingsSettings => {
  var _bookingsSettings$sta;
  return ((_bookingsSettings$sta = bookingsSettings.staffSelection) == null ? void 0 : _bookingsSettings$sta.strategy) === _types.Strategy.CUSTOMER_CANNOT_CHOOSE;
};
exports.isCustomerCannotChooseStaff = isCustomerCannotChooseStaff;
const isCustomerMayChooseStaff = bookingsSettings => {
  var _bookingsSettings$sta2;
  return ((_bookingsSettings$sta2 = bookingsSettings.staffSelection) == null ? void 0 : _bookingsSettings$sta2.strategy) === _types.Strategy.CUSTOMER_MAY_CHOOSE;
};
exports.isCustomerMayChooseStaff = isCustomerMayChooseStaff;
const isCustomerMustChooseStaff = bookingsSettings => {
  var _bookingsSettings$sta3;
  return ((_bookingsSettings$sta3 = bookingsSettings.staffSelection) == null ? void 0 : _bookingsSettings$sta3.strategy) === _types.Strategy.CUSTOMER_MUST_CHOOSE;
};
exports.isCustomerMustChooseStaff = isCustomerMustChooseStaff;
const isStaffSelectionBeforeSlot = bookingsSettings => {
  var _bookingsSettings$sta4;
  return ((_bookingsSettings$sta4 = bookingsSettings.staffSelection) == null ? void 0 : _bookingsSettings$sta4.timing) === _types.StaffSelectionTiming.BEFORE_SLOT_SELECTION;
};
exports.isStaffSelectionBeforeSlot = isStaffSelectionBeforeSlot;
const isStaffSelectionAfterSlot = bookingsSettings => {
  var _bookingsSettings$sta5;
  return ((_bookingsSettings$sta5 = bookingsSettings.staffSelection) == null ? void 0 : _bookingsSettings$sta5.timing) === _types.StaffSelectionTiming.AFTER_SLOT_SELECTION;
};
exports.isStaffSelectionAfterSlot = isStaffSelectionAfterSlot;
const isLocationSelectionBeforeSlot = bookingsSettings => {
  var _bookingsSettings$loc;
  return ((_bookingsSettings$loc = bookingsSettings.locationSelection) == null ? void 0 : _bookingsSettings$loc.timing) === _types.Timing.BEFORE_SLOT_SELECTION;
};
exports.isLocationSelectionBeforeSlot = isLocationSelectionBeforeSlot;
const isLocationSelectionAfterSlot = bookingsSettings => {
  var _bookingsSettings$loc2;
  return ((_bookingsSettings$loc2 = bookingsSettings.locationSelection) == null ? void 0 : _bookingsSettings$loc2.timing) === _types.Timing.AFTER_SLOT_SELECTION;
};
exports.isLocationSelectionAfterSlot = isLocationSelectionAfterSlot;
const hasRequiredBookFlowSettings = bookingsSettings => {
  if (!bookingsSettings) {
    return false;
  }
  const isValidStaffStrategy = isCustomerCannotChooseStaff(bookingsSettings) || isCustomerMayChooseStaff(bookingsSettings) || isCustomerMustChooseStaff(bookingsSettings);
  const isValidStaffTiming = isStaffSelectionBeforeSlot(bookingsSettings) || isStaffSelectionAfterSlot(bookingsSettings);
  const isValidLocationTiming = isLocationSelectionBeforeSlot(bookingsSettings) || isLocationSelectionAfterSlot(bookingsSettings);
  return isValidStaffStrategy && isValidStaffTiming && isValidLocationTiming;
};
exports.hasRequiredBookFlowSettings = hasRequiredBookFlowSettings;
const isBookFlowSettingsEnabled = ({
  experiments,
  bookingsSettings
}) => {
  return !!(experiments != null && experiments.enabled('specs.bookings.BookFlowSettings')) && hasRequiredBookFlowSettings(bookingsSettings);
};
exports.isBookFlowSettingsEnabled = isBookFlowSettingsEnabled;
//# sourceMappingURL=bookingsSettings.js.map